import { computed } from "vue";
import type { FrictionCtx } from "./context";

// Tubing and casing friction losses.
export const defineFriction = (ctx: FrictionCtx) => {
  const { stageFluidProperties } = ctx;

  const tubingFrictionLossPSIA = computed(() => {
    return stageFluidProperties.value.tubingFrictionLossPSIA;
  });

  const topTubingFrictionProperties = computed(() => {
    return stageFluidProperties.value.topTubingFrictionProperties;
  });

  const bottomTubingFrictionProperties = computed(() => {
    return stageFluidProperties.value.bottomTubingFrictionProperties;
  });

  const casingFrictionLossPSIA = computed(() => {
    return stageFluidProperties.value.casingFrictionLossPSIA;
  });

  const perfsAndDatumCasingFrictionPSIA = computed(() => {
    return stageFluidProperties.value.perfsAndDatumCasingFrictionPSIA;
  });

  const bottomOfEquipmentCasingFrictionPSIA = computed(() => {
    return stageFluidProperties.value.bottomOfEquipmentCasingFrictionPSIA;
  });

  const sensorAndMotorCasingFrictionPSIA = computed(() => {
    return stageFluidProperties.value.sensorAndMotorCasingFrictionPSIA;
  });

  const motorAndSealsCasingFrictionPSIA = computed(() => {
    return stageFluidProperties.value.motorAndSealsCasingFrictionPSIA;
  });

  const sealsAndIntakesCasingFrictionPSIA = computed(() => {
    return stageFluidProperties.value.sealsAndIntakesCasingFrictionPSIA;
  });

  return {
    tubingFrictionLossPSIA,
    topTubingFrictionProperties,
    bottomTubingFrictionProperties,
    casingFrictionLossPSIA,
    perfsAndDatumCasingFrictionPSIA,
    bottomOfEquipmentCasingFrictionPSIA,
    sensorAndMotorCasingFrictionPSIA,
    motorAndSealsCasingFrictionPSIA,
    sealsAndIntakesCasingFrictionPSIA
  };
};

export type FrictionCalcs = ReturnType<typeof defineFriction>;
